import React, { useRef, useState, useEffect } from "react";
import { Menu } from "@headlessui/react";
import {
  ChevronDownIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const CustomDropdownCountry = ({
  menuItems,
  textColor,
  title,
  onSelect,
  selected,
}) => {
  const buttonRef = useRef(null);
  const searchInputRef = useRef(null);
  const [buttonWidth, setButtonWidth] = useState(0);
  const [selectedItem, setSelectedItem] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const direction = useLanguageDirection();
  // Filter items based on search query
  const filteredItems = menuItems.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, []);

  const { t } = useTranslation();

  // Clear search when menu closes
  const handleMenuClose = () => {
    setSearchQuery("");
  };

  // Focus on search input when menu opens
  const handleMenuOpen = () => {
    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 100);
  };

  return (
    <Menu
      as="div"
      className="relative inline-block w-full mb-3"
      dir={direction}
    >
      {({ open }) => (
        <>
          <div>
            <h4 className="mb-2 text-lg text-gray-800">{title}</h4>
            <Menu.Button
              ref={buttonRef}
              onClick={open ? handleMenuClose : handleMenuOpen}
              className={`flex items-center justify-between rounded-md bg-white border w-full border-gray-300 p-2 font-medium text-gray-700 `}
            >
              <span className="text-black">
                {menuItems.find((item) => item.id === selected)?.name ||
                  t("calculateShippingSection.selectCountry")}
              </span>
              <ChevronDownIcon className="w-6 h-6 text-black" />
            </Menu.Button>
          </div>

          <Menu.Items
            className="absolute z-40 w-full mt-1 overflow-y-auto bg-white border border-gray-300 rounded-md shadow-lg end-0 focus:outline-none max-h-70"
            style={{ width: buttonWidth }}
          >
            {/* Search Input */}
            <div className="sticky top-0 p-2 bg-white border-b border-gray-200">
              <div className="relative">
                <MagnifyingGlassIcon className="absolute w-4 h-4 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />
                <input
                  ref={searchInputRef}
                  type="text"
                  placeholder={direction === "rtl" ? "البحث..." : "Search..."}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full py-2 pl-10 pr-3 text-base text-black bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:border-transparent"
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            </div>

            {/* Menu Items */}
            <div className="overflow-y-auto max-h-48">
              {filteredItems.length > 0 ? (
                filteredItems.map((item) => (
                  <Menu.Item key={item.id}>
                    {({ active }) => (
                      <button
                        onClick={() => {
                          setSelectedItem(item.name);
                          onSelect(item);
                          setSearchQuery("");
                        }}
                        className={`px-4 py-2 text-sm text-start flex items-center gap-2 w-full ${
                          active ? "bg-gray-100 text-gray-900" : "text-gray-700"
                        }`}
                      >
                        <img
                          src={item.flag}
                          alt={item.name}
                          className="w-6 h-4 "
                        />
                        {item.name}
                      </button>
                    )}
                  </Menu.Item>
                ))
              ) : (
                <div className="px-4 py-2 text-sm text-center text-gray-500">
                  {direction === "rtl" ? "لا توجد نتائج" : "No results found"}
                </div>
              )}
            </div>
          </Menu.Items>
        </>
      )}
    </Menu>
  );
};

export default CustomDropdownCountry;
